export interface DisputeTrackingStatusProps {
  disputeTrackingStatusId: number;
  disputeTrackingStatusName: string;
  disputeTrackingStatusKey: string;
}

export class DisputeTrackingStatus {
  private readonly _disputeTrackingStatusId: number;
  private readonly _disputeTrackingStatusName: string;
  private readonly _disputeTrackingStatusKey: string;

  constructor(props: DisputeTrackingStatusProps) {
    this._disputeTrackingStatusId = props.disputeTrackingStatusId;
    this._disputeTrackingStatusName = props.disputeTrackingStatusName;
    this._disputeTrackingStatusKey = props.disputeTrackingStatusKey;
  }

  public get disputeTrackingStatusId(): number {
    return this._disputeTrackingStatusId;
  }

  public get disputeTrackingStatusName(): string {
    return this._disputeTrackingStatusName;
  }

  public get disputeTrackingStatusKey(): string {
    return this._disputeTrackingStatusKey;
  }
}
